export { default, GoogleAddressInputHandler } from './GoogleAddressInput.js';
